import React, { useEffect, useRef } from 'react';
import { View, Text, Animated } from 'react-native';

import { styles } from './styles';

export const Noti = ({
  customStyles = {},
  title="нотификация",
  titleStyle = null,
  visible = false,
}) => {
  //const fadeAnim = new Animated.Value(0);

  const fadeAnim = useRef(new Animated.Value(0)).current;

  const fadeIn = () => {
    // Will change fadeAnim value to 1 in 5 seconds
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 500,
      useNativeDriver: true,
    }).start();
  };

  const fadeOut = () => {
    // Will change fadeAnim value to 0 in 3 seconds
    Animated.timing(fadeAnim, {
      toValue: 0,
      duration: 500,
      useNativeDriver: true,
    }).start();
  };

  useEffect(() => {
    if (!!title) {
      setTimeout(fadeIn, 200);
    } else {
      fadeOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return (
    <Animated.View
      style={{
        position: 'absolute',
        //top: 0,
        bottom: '15%',
        alignSelf: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
        //paddingHorizontal: 40,
        minWidth: '50%',
        paddingVertical: 10,
        borderRadius: 20,
        opacity: fadeAnim,
      }}
    >
      <Text style={{ color: 'white', fontWeight: 'bold', marginHorizontal: 20 }}>{title}</Text>
    </Animated.View>
  );
};
